
export default function tr(...p) {
	let translator = window.translator.context('default');
	return translator.translate(...p);
}
